import React from 'react';
import { Background, BackgroundProps } from 'react-imgix';

import { CardMedia } from '@hbf/dsl';
import NoPhotoImg from 'ha/img-src/static/nophotos.png';

import { isValidImgixSource } from './isValidImgixSource';
import { useImgix } from './useImgix';

export const ImgixBackground: React.FC<BackgroundProps> = ({
  src,
  ...props
}) => {
  const { transformImageURL } = useImgix();
  return !src || !isValidImgixSource(src) ? (
    <CardMedia
      {...props}
      image={src || NoPhotoImg}
      data-test-locator={
        props?.htmlAttributes?.['data-test-locator'] || 'imgix'
      }
    />
  ) : (
    <Background
      {...props}
      htmlAttributes={{ 'data-test-locator': 'imgix', ...props.htmlAttributes }}
      src={transformImageURL(src)}
    />
  );
};
